import React from 'react';
import PropTypes from 'prop-types';
import QuantityInput from 'base/components/QuantityInput';

/**
 * This is quantity input component that needs to be used
 * as a component prop in redux-form.
 */
const QuantityInputField = props => {
  const { input, disableDecrement, disableIncrement } = props;
  return (
    <QuantityInput
      label="Qty"
      value={input.value || 1}
      disableDecrement={disableDecrement}
      disableIncrement={disableIncrement}
      onChange={event => input.onChange(event.target.value)}
    />
  );
};

QuantityInputField.propTypes = {
  input: PropTypes.object,
  disableDecrement: PropTypes.bool,
  disableIncrement: PropTypes.bool
};

export default QuantityInputField;
